import { useContext } from "react";
import { DrawRequestContext, TestDetailsContext } from "@app/provider";
import { getProsperaEbdd } from "@app/utils/prosperaEbdd";

/** The dates a draw is scheduled around, from the portal test or the guest's draw. */
const useExpectedDrawDates = () => {
  const { getTestDetails } = useContext(TestDetailsContext);
  const testDetails = getTestDetails();
  const { verifiedSampleDrawData } = useContext(DrawRequestContext);
  const sample = verifiedSampleDrawData?.sampleInfo.sample;

  return {
    isOncologyOrder: testDetails?.isOncologyOrder ?? sample?.isOncologyOrder,
    sampleCollectionDate:
      testDetails?.sampleCollectionDate ?? sample?.sampleCollectionDate,
    prosperaEbdd: getProsperaEbdd({
      testType: testDetails?.testType ?? sample?.testType,
      organType: testDetails?.organType ?? sample?.organType,
      resultExpectedByDate:
        testDetails?.resultExpectedByDate ?? sample?.resultExpectedByDate,
    }),
  };
};

export default useExpectedDrawDates;
